import { MasterProductModel } from '../models/masterProduct';
import axios from '../lib/axios';
import {
  GET_COUNT_MASTER_PRODUCT,
  MASTER_PRODUCT_UPDATE,
  PRODUCT_MASTER_FIND_MANY,
  PRODUCT_MASTER_FIND_ONE,
  SEARCH_MASTER_PRODUCT,
} from '../lib/endpoints/product';
import { concatenateStrings } from '../utils/concatenateStrings';

interface InputGetMasterProduct {
  take: number;
  skip?: number;
  masterMainGroupId?: string;
  divisionId?: string;
  categoryId?: string;
  subCategoryId?: string;
}

export const getProduct = async ({
  take,
  skip,
  masterMainGroupId,
  divisionId,
  categoryId,
  subCategoryId,
}: InputGetMasterProduct): Promise<MasterProductModel[]> => {
  let filtter: any = {};
  if (masterMainGroupId) {
    filtter.masterMainGroupId = masterMainGroupId;
  }
  if (divisionId) {
    filtter.masterDivisionNameId = divisionId;
  }
  if (categoryId) {
    filtter.masterProductCategoryId = categoryId;
  }
  if (subCategoryId) {
    filtter.masterProductSubCategoryId = subCategoryId;
  }
  const res = await axios.post(PRODUCT_MASTER_FIND_MANY, {
    filtter,
    take,
    skip,
  });

  return res?.data;
};

export const getCategoryActiveProduct = async (value: boolean): Promise<MasterProductModel[]> => {
  const res = await axios.post(PRODUCT_MASTER_FIND_MANY);

  const getData = res?.data.filter((item: MasterProductModel) => {
    const isNullOrEmptyString =
      item.masterMainGroupId === null || item.masterMainGroupId === 'null';

    if (value === true) {
      return item.masterMainGroupId && !isNullOrEmptyString;
    } else {
      return !item.masterMainGroupId || isNullOrEmptyString;
    }
  });
  return getData;
};

export const getCountMasterProduct = async (): Promise<number> => {
  const res = await axios.get(GET_COUNT_MASTER_PRODUCT);

  return res?.data?.data?.All?._all;
};

export const searchMasterProduct = async (search: string): Promise<MasterProductModel[]> => {
  const filtter = search ? { name: search } : {};

  const res = await axios.post(PRODUCT_MASTER_FIND_MANY, {
    filtter,
  });

  if (Array.isArray(res.data) && res.data.length === 0) {
    return await searchMasterProductByItemCode(search);
  }

  return res?.data;
};

export const searchMasterProductByItemCode = async (
  search: string
): Promise<MasterProductModel[]> => {
  const filtter = search ? { itemcode: search } : {};

  const res = await axios.post(PRODUCT_MASTER_FIND_MANY, {
    filtter,
  });

  return res?.data;
};
// export const searchMasterProduct = async (search: string): Promise<MasterProductModel[]> => {
//   const res = await axios.post(PRODUCT_MASTER_FIND_MANY);

//   const data = res?.data.filter((item: any) => {
//     return (
//       item?.itemcode.toLowerCase()?.includes(search.toLowerCase()) ||
//       item?.itemcode.toLowerCase()?.includes(search.toLowerCase()) ||
//       item?.productNameEn.toLowerCase()?.includes(search.toLowerCase()) ||
//       item?.productNameLa.toLowerCase()?.includes(search.toLowerCase()) ||
//       concatenateStrings(item?.barcodes).toString().toLowerCase()?.includes(search.toLowerCase())
//     );
//   });

//   return data;
// };

export const uploadMultipleImage = async (files: File[]): Promise<void> => {
  const res = await axios.post(PRODUCT_MASTER_FIND_MANY);

  const data = res?.data;

  for (const item of files) {
    const formData = new FormData();
    formData.append('mainImage', item);
    try {
      const getProductId: string = data.filter((subItem: MasterProductModel) =>
        subItem.barcodes.includes(removeFileExtension(item?.name))
      )[0].id;
      await axios.patch(`${MASTER_PRODUCT_UPDATE}?id=${getProductId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      });
    } catch (err) {
      // console.log('error=', err);
    }
  }
  window.alert('upload file successful ' + files?.length + ' files');
};

function removeFileExtension(filename: string): string {
  const lastDotIndex = filename.lastIndexOf('.');

  if (lastDotIndex === -1) {
    return filename; // No file extension found
  }

  return filename.substring(0, lastDotIndex);
}

export const getProductById = async (id: string) => {
  const resData = await axios.get(`${PRODUCT_MASTER_FIND_ONE}?id=${id}`);
  return resData.data;
};
